// project imports
import capabilities from './capabilities';
import { appState } from 'store/behaviors/loader';

const initialState = {
    ...appState(capabilities)
};

export default initialState;
